// extracted by mini-css-extract-plugin
module.exports = {"slider":"slider_slider__1xJxX","mover":"slider_mover__1EbXs","draggable":"slider_draggable__1uB2q","prev":"slider_prev__206Jl","next":"slider_next__1ZzmI"};